import React, {useState} from 'react';

import './Account.css'
import {StandardButton} from "../../common/button/standard-button/StandardButton";
import {LeftLabelToggle} from "../../common/input/left-label-toggle/LeftLabelToggle";
import {LeftLabelSelect} from "../../common/input/left-label-select/LeftLabelSelect";
import {updateSystemUserSettings} from "../../../services/AccountService";

export const Account = ({context, setContext, setSpinnerText, showToaster}) => {

    const [tooltipsEnabled, setTooltipsEnabled] = useState(context.loggedInUser.toolTipsEnabled);
    const [suggestionsSort, setSuggestionsSort] = useState({
        label: context.loggedInUser.sortBySuggestion,
        value: context.loggedInUser.sortBySuggestion
    });
    const [dropDownOptions] = useState([
        {label: "Recently edited", value: "Recently edited"},
        {label: "Most edited", value: "Most edited"},
    ]);

    const handleSaveClick = async () => {
        setSpinnerText("Updating Settings");

        const systemUserVOToUpdate = {
            externalReference: context.loggedInUser.externalReference,
            toolTipsEnabled: tooltipsEnabled,
            sortBySuggestion: suggestionsSort.value,
        };

        const response = await updateSystemUserSettings(context.username, systemUserVOToUpdate);
        handleResponse(response);
    }

    const handleResponse = ([data, error]) => {
        if (data) {
            if (data.responseStatus === "Success") {
                setContext((prevState) => ({
                    ...prevState,
                    loggedInUser: {
                        ...prevState.loggedInUser,
                        sortBySuggestion: data.updatedSystemUserVO.sortBySuggestion,
                        toolTipsEnabled: data.updatedSystemUserVO.toolTipsEnabled,
                    }
                }));
            }
            showToaster(data);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        setSpinnerText(null);
    }

    return (
        <div className="account-container">
            <div className="account-content-container">
                <LeftLabelToggle labelText="Show Tooltips:"
                                 active={tooltipsEnabled}
                                 setActive={setTooltipsEnabled}/>
                <LeftLabelSelect labelText="Sort Top Suggestions By:"
                                 value={suggestionsSort}
                                 options={dropDownOptions}
                                 onChange={(selectedOption) => {
                                     setSuggestionsSort(selectedOption);
                                 }}/>
                <div className="account-button-container">
                    <StandardButton text="Save Settings"
                                    onClick={handleSaveClick}/>
                </div>
            </div>
        </div>
    );
}
